module.exports = __webpack_public_path__ + "img/ill_5.e37e397f.png";